export const cmifUtils = {

  props: {
    ca: { type: Array, default: null }
  },

  methods: {
    getEntities (context, elementNames) {
      const poo = []
      const action = this.ca.find(a => a['@type'] === context)
      if (typeof action === 'object') {
        for (const [el, val] of Object.entries(action)) {
          if (elementNames.indexOf(el) > -1) {
            if (Array.isArray(val)) {
              val.forEach(v => {
                poo.push({
                  key: el,
                  value: v
                })
              })
            } else {
              poo.push({
                key: el,
                value: val
              })
            }
          }
        }
      }
      return poo
    }
  }
}

export default cmifUtils
